export var Pronouns;
(function (Pronouns) {
    Pronouns["They"] = "They";
    Pronouns["He"] = "He";
    Pronouns["She"] = "She";
})(Pronouns || (Pronouns = {}));
export const PronounTexts = {
    They: {
        s: 'they',
        o: 'them',
        p: 'their',
        pp: 'theirs',
        r: 'themself',
    },
    He: {
        s: 'he',
        o: 'him',
        p: 'his',
        pp: 'his',
        r: 'himself',
    },
    She: {
        s: 'she',
        o: 'her',
        p: 'her',
        pp: 'hers',
        r: 'herself',
    },
};
//# sourceMappingURL=Pronouns.js.map